'use strict';

var cov_21tsej2wre = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Backdrop/lib/Backdrop.js',
      hash = 'cba496023516edd80b8de853a57b7cff98dd93a5',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Backdrop/lib/Backdrop.js',
    statementMap: {
      '0': {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 24,
          column: 1
        }
      },
      '1': {
        start: {
          line: 26,
          column: 19
        },
        end: {
          line: 41,
          column: 1
        }
      },
      '2': {
        start: {
          line: 43,
          column: 27
        },
        end: {
          line: 63,
          column: 1
        }
      },
      '3': {
        start: {
          line: 65,
          column: 24
        },
        end: {
          line: 82,
          column: 1
        }
      },
      '4': {
        start: {
          line: 87,
          column: 17
        },
        end: {
          line: 97,
          column: 1
        }
      },
      '5': {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 96,
          column: 12
        }
      },
      '6': {
        start: {
          line: 99,
          column: 0
        },
        end: {
          line: 106,
          column: 2
        }
      },
      '7': {
        start: {
          line: 108,
          column: 0
        },
        end: {
          line: 112,
          column: 2
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 87,
            column: 17
          },
          end: {
            line: 87,
            column: 18
          }
        },
        loc: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 96,
            column: 12
          }
        },
        line: 88
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 90,
            column: 5
          },
          end: {
            line: 94,
            column: 5
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 90,
            column: 5
          },
          end: {
            line: 90,
            column: 13
          }
        }, {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 93,
            column: 27
          }
        }],
        line: 90
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0
    },
    f: {
      '0': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  &:hover {\n    .g-restrictedBackdrop {\n      opacity: 1;\n      top: 0;\n      -webkit-transition-delay: 0s;\n      -moz-transition-delay: 0s;\n      -o-transition-delay: 0s;\n      -ms-transition-delay: 0s;\n      transition-delay: 0s;\n    }\n  }\n'], ['\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  &:hover {\n    .g-restrictedBackdrop {\n      opacity: 1;\n      top: 0;\n      -webkit-transition-delay: 0s;\n      -moz-transition-delay: 0s;\n      -o-transition-delay: 0s;\n      -ms-transition-delay: 0s;\n      transition-delay: 0s;\n    }\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ', ';\n  display: flex;\n  z-index: 2;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ', ';\n  display: flex;\n  z-index: 2;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5); // TODO\n  display: block;\n  z-index: 2;\n  opacity: 0;\n  height: 100%;\n  text-align: center;\n\n  -webkit-transition: all 0.3s ease-out 0.3s;\n  -moz-transition: all 0.3s ease-out 0.3s;\n  -o-transition: all 0.3s ease-out 0.3s;\n  -ms-transition: all 0.3s ease-out 0.3s;\n  transition: all 0.3s ease-out 0.3s;\n'], ['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5); // TODO\n  display: block;\n  z-index: 2;\n  opacity: 0;\n  height: 100%;\n  text-align: center;\n\n  -webkit-transition: all 0.3s ease-out 0.3s;\n  -moz-transition: all 0.3s ease-out 0.3s;\n  -o-transition: all 0.3s ease-out 0.3s;\n  -ms-transition: all 0.3s ease-out 0.3s;\n  transition: all 0.3s ease-out 0.3s;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  white-space: normal;\n  color: white;\n  span,\n  a {\n    padding: ', ';\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-decoration: none;\n    font-size: ', ';\n  }\n'], ['\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  white-space: normal;\n  color: white;\n  span,\n  a {\n    padding: ', ';\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-decoration: none;\n    font-size: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stylingConstants = require('@gravity/styling-constants');

var _stylingConstants2 = _interopRequireDefault(_stylingConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = (cov_21tsej2wre.s[0]++, _styledComponents2.default.div.attrs({
  className: 'g-backdropContainer'
})(_templateObject));

var BackdropEl = (cov_21tsej2wre.s[1]++, _styledComponents2.default.div.attrs({
  className: 'g-backdrop'
})(_templateObject2, _stylingConstants2.default.color.backdrop));

var RestrictedBackdrop = (cov_21tsej2wre.s[2]++, _styledComponents2.default.div.attrs({
  className: 'g-restrictedBackdrop'
})(_templateObject3));

var BackdropContent = (cov_21tsej2wre.s[3]++, _styledComponents2.default.div.attrs({
  className: 'g-backdropContent'
})(_templateObject4, _stylingConstants2.default.spacing.small, _stylingConstants2.default.font.sizeS));

/*
 * Component that wrapp objects and display a backdrop over it.
 */
cov_21tsej2wre.s[4]++;
var Backdrop = function Backdrop(_ref) {
  var children = _ref.children,
      backdropContent = _ref.backdropContent,
      animated = _ref.animated;
  cov_21tsej2wre.f[0]++;
  cov_21tsej2wre.s[5]++;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(BackdropEl, null),
    (cov_21tsej2wre.b[0][0]++, animated) && (cov_21tsej2wre.b[0][1]++, _react2.default.createElement(
      RestrictedBackdrop,
      null,
      _react2.default.createElement(
        BackdropContent,
        null,
        ' ',
        backdropContent
      )
    )),
    children
  );
};

cov_21tsej2wre.s[6]++;
Backdrop.propTypes = {
  /** Display only the backdrop if the mouse is over */
  animated: _propTypes2.default.bool,
  /** children is the content that should be wrapped */
  children: _propTypes2.default.node,
  /** backdropContent is the content that is displayed on the backdropContent */
  backdropContent: _propTypes2.default.node
};

cov_21tsej2wre.s[7]++;
Backdrop.defaultProps = {
  animated: false,
  children: '',
  backdropContent: null
};

exports.default = Backdrop;